import { render, staticRenderFns } from "./AepNetworkBlock.vue?vue&type=template&id=24b7abae&lang=pug"
import script from "./AepNetworkBlock.vue?vue&type=script&lang=js"
export * from "./AepNetworkBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlanProvidersList: require('/home/docker/code/frontend/components/PlanProvidersList.vue').default})
